import { useMemo } from 'react';
import { CalendarDay } from '../types';
import './DaysList.css';

interface DaysListProps {
  calendar: CalendarDay[];
  onDayClick: (day: string) => void;
}

export default function DaysList({ calendar, onDayClick }: DaysListProps) {
  const sortedDays = useMemo(() => {
    return [...calendar].sort((a, b) => a.date.localeCompare(b.date));
  }, [calendar]);

  return (
    <div className="days-list">
      <div className="days-list-header">
        <h2>All Days</h2>
      </div>
      <div className="days-list-content">
        {sortedDays.map((day, index) => {
          const year = day.date.split('-')[0];
          return (
            <button
              key={day.date}
              className="day-item"
              onClick={() => onDayClick(day.date)}
            >
              <span className="day-number">Day {index + 1}</span>
              <span className="day-date">{day.date_str} {year}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

